import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class DeleteEmailTemplateCommand extends IRequestCommand<
  IDeleteEmailTemplateCommandResponse,
  ErrorDetails,
  IDeleteEmailTemplateCommandParameters> {
  override _commandType: CommandRequestType = CommandRequestType.DELETE;
  override _commandUrl = 'carriers/emailsTemplates/{id}';

  public override setParameters(parameters: IDeleteEmailTemplateCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{id}',
      parameters.idTemplate ? parameters.idTemplate.toString() : ''
    );
    this._commandBody = parameters;
  }
}

export interface IDeleteEmailTemplateCommandParameters {
  idTemplate: number;
}

export interface IDeleteEmailTemplateCommandResponse extends ICommandResponse {
}
